import axios from 'axios'

const configurarpedidos = {

    PostCrearEditar: (datos) => axios.post(`pedidos-minimo/crear-pedidos-minimo`,datos),
    activarInactiva: (datos) => axios.post(`pedidos-minimo/estado-pedidos-minimo`,datos),
    GetTPedidosMinimo: (id) => axios.get(`pedidos-minimo/${id}/listar-pedidos-minimos`),
}
export default configurarpedidos
